import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { z } from "zod";

export const watchFulfillmentGroups = unaryStreamRpc({
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupDataSchema) }),
});
